import React, {useEffect, useMemo, useState} from "react";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
import { DiApple } from "react-icons/di";
import { DiAndroid } from "react-icons/di";
// Assets
// import CardMenu from "components/card/CardMenu";
import {MdChevronLeft, MdChevronRight, MdEdit} from "react-icons/md";
import Card from "components/card";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
// import axios from "axios";
import {FiSearch} from "react-icons/fi";

const ManagementTable = (props) => {
    const {columnsData, tableData, onRowClick} = props;

    const columns = useMemo(() => columnsData, [columnsData]);
    //const data = useMemo(() => tableData, [tableData]);

    function convertGMTtoIST(gmtDateTime) {
        //console.log("Date: " + gmtDateTime);
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    const [message, setErrorMessage] = useState("");

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [allFeedbacks, setAllFeedbacks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [searchText, setSearchText] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [platformFilter, setPlatformFilter] = useState("");
    const [versionFilter, setVersionFilter] = useState("");

    const getPlatform = (version = "") => /ios|iphone|ipad|\(/i.test(version) ? "iOS" : "Android";
    const categoryOptions = useMemo(() => [...new Set((tableData || []).map(item => item.categoryOnly).filter(Boolean))].sort(), [tableData]);
    const versionOptions = useMemo(() => [...new Set((tableData || []).map(item => item.appVer).filter(Boolean))].sort(), [tableData]);
    const data = useMemo(() => (tableData || []).filter(item =>
        (!categoryFilter || item.categoryOnly === categoryFilter) &&
        (!platformFilter || getPlatform(item.appVer) === platformFilter) &&
        (!versionFilter || item.appVer === versionFilter)
    ), [tableData, categoryFilter, platformFilter, versionFilter]);

    const navigate = useNavigate();

    let [editable, setFeedbackEdit] = useState(false);

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    let [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -11));
    let [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10))

    function handleStartDateChange(lowerDate){
        setLowerDate(lowerDate)
        sessionStorage.setItem("startDate", lowerDate)
    }

    function handleEndDateChange(upperDate){
        setUpperDate(upperDate)
        sessionStorage.setItem("endDate", upperDate)
    }

    // This block runs only once and creates a fast lookup map.
    const deviceNameMap = useMemo(() => {
        const catalogString = sessionStorage.getItem("productCatalogArray");
        if (!catalogString) {
            console.warn("productCatalogArray not found in sessionStorage.");
            return new Map(); // Return an empty map if data doesn't exist
        }

        try {
            const productCatalog = JSON.parse(catalogString);
            // Create a Map where: key = deviceAddress, value = deviceName
            return new Map(
                productCatalog.map(item => [item.productId, item.product])
            );
        } catch (error) {
            console.error("Failed to parse productCatalogArray from sessionStorage:", error);
            return new Map(); // Return an empty map on parsing error
        }
    }, []); // The empty dependency array [] ensures this runs only once

    const getDeviceNameByAddress = (address) => {
        if (!address) {
            return "N/A"; // Handle cases where address is null or undefined
        }
        // Use the map to find the name. Provide a fallback if not found.
        return deviceNameMap.get(address) || "Unknown Device";
    };

    //let productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"))

    return (
        <Card extra={"w-full px-9 py-3 h-full"}>
            <div className="mt-2 flex w-full flex-col gap-3 px-1">
                {/*<h4 className="font-dm text-xl font-bold text-navy-700 dark:text-white">
          Team Management
        </h4>*/}
                <div className="flex justify-between">
                    <button
                        className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer
                    hover:bg-gray-100 active:bg-gray-200 dark:bg-white dark:hover:opacity-90 dark:active:opacity-80">
                        <input type={"date"} id="startDate" className="datePicker" value={LowerDate}
                               onChange={(e) => handleStartDateChange(e.target.value)}/>
                        <input type={"date"} id="endDate" className="datePicker" value={UpperDate}
                               onChange={(e) => handleEndDateChange(e.target.value)}/>
                        {/*<span className="text-sm font-medium text-gray-600 react"></span>*/}
                    </button>
                </div>
                <div className="flex flex-wrap items-center gap-3">
                    <label className="relative min-w-[240px] flex-1">
                        <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"/>
                        <input
                            type="search"
                            value={searchText}
                            onChange={(event) => { setSearchText(event.target.value); setGlobalFilter(event.target.value || undefined); }}
                            placeholder="Search feedback, user, device..."
                            className="h-10 w-full rounded-lg border border-gray-300 bg-white pl-10 pr-3 text-sm outline-none focus:border-[#004c86] dark:border-white/10 dark:bg-navy-800 dark:text-white"
                        />
                    </label>
                    <select aria-label="Filter by category" value={categoryFilter} onChange={(event) => setCategoryFilter(event.target.value)} className="h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white">
                        <option value="">All categories</option>
                        {categoryOptions.map(category => <option key={category} value={category}>{category}</option>)}
                    </select>
                    <select aria-label="Filter by app platform" value={platformFilter} onChange={(event) => setPlatformFilter(event.target.value)} className="h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white">
                        <option value="">All apps</option><option value="Android">Android</option><option value="iOS">iOS</option>
                    </select>
                    <select aria-label="Filter by app version" value={versionFilter} onChange={(event) => setVersionFilter(event.target.value)} className="h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white">
                        <option value="">All versions</option>
                        {versionOptions.map(version => <option key={version} value={version}>{version}</option>)}
                    </select>
                    {(searchText || categoryFilter || platformFilter || versionFilter) && <button type="button" onClick={() => { setSearchText(""); setGlobalFilter(undefined); setCategoryFilter(""); setPlatformFilter(""); setVersionFilter(""); }} className="h-10 rounded-lg border border-[#004c86] px-4 text-sm font-semibold text-[#004c86] hover:bg-blue-50">Clear</button>}
                </div>
                {/*<CardMenu/>*/}
            </div>
            {/* tables */}
            <div className="mt-[25px] overflow-x-auto max-w-full">
                {data.length === 0 && <p className="py-8 text-center text-sm text-gray-600 dark:text-gray-300">No feedback matches the selected filters.</p>}
                <table
                    {...getTableProps()}
                    className="table-auto whitespace-nowrap font-dm text-navy-700"
                >
                    <thead>
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                            className="border-b border-gray-200 text-base dark:border-white/10"
                        >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className="pb-[15px] pl-[5px] pr-[20px] text-start text-sm font-bold uppercase tracking-wide text-gray-600"
                                    key={index}
                                >
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row, index) => {
                        prepareRow(row);
                        return (
                            <tr
                                {...row.getRowProps()}
                                key={index}
                                onClick={() => onRowClick?.(row.original)}
                                onKeyDown={(event) => {
                                    if (onRowClick && (event.key === "Enter" || event.key === " ")) {
                                        event.preventDefault();
                                        onRowClick(row.original);
                                    }
                                }}
                                role={onRowClick ? "button" : undefined}
                                tabIndex={onRowClick ? 0 : undefined}
                                className={`items-center border-b border-gray-100 transition dark:border-white/5 ${onRowClick ? "cursor-pointer hover:bg-blue-50/70 focus:bg-blue-50/70 focus:outline-none dark:hover:bg-white/5" : ""}`}
                            >
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    if (cell.column.Header === "Category") {
                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] pr-4">
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {cell.value}
                                                </p>
                                            </div>
                                        );
                                    }
                                    else if (cell.column.Header === "User") {
                                        // Always extract user info from the category field (most reliable)
                                        const categoryValue = cell.row.original?.category || "";
                                        const userInfo = categoryValue.split(' - ').pop() || 'N/A';

                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] pr-4">
                                                <p className="text-sm font-medium text-gray-600 dark:text-white">
                                                    {userInfo}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "Device Address") {
                                        // Access the nested property safely from the original row data
                                        const deviceAddress = cell.row.original?.deviceInfo?.deviceAddress;

                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] pr-4">
                                                <p className="text-sm font-medium text-gray-600">
                                                    {/* Display the address or a fallback like 'N/A' if it's missing */}
                                                    {deviceAddress || 'N/A'}
                                                </p>
                                            </div>
                                        );
                                    }
                                    else if (cell.column.Header === "Product Name") {
                                        // Access the nested property safely from the original row data
                                        const productId = cell.row.original?.deviceInfo?.productId;
                                        // 2. Use your efficient lookup function to get the name
                                        const productName = getDeviceNameByAddress(productId);

                                        // 3. Render the result
                                        data = (
                                            <div className="flex flex-col min-w-[200px] pr-4">
                                                {/* Display the device name prominently */}
                                                <p className="text-sm font-medium text-gray-800">
                                                    {productName}
                                                </p>
                                            </div>
                                        );
                                    }
                                    else if (
                                        ["Sub Category"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /*<div className="text-sm font-bold dark:text-white min-w-[120px]">*/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value}
                                                </div>
                                            </div>
                                        );
                                    }
                                    else if (
                                        ["Feedback"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            <div className="flex items-center gap-2 min-w-[600px] max-w-[800px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value}
                                                </div>
                                            </div>
                                        );
                                    }else if (
                                        ["App Version"].includes(cell.column.Header)
                                    ) {
                                        const version = cell.value || "";

                                        // Decide icon
                                        const platformIcon = version.includes("(") ? (
                                            <DiApple className="text-gray-700 text-xl" />
                                        ) : (
                                            <DiAndroid className="text-green-600 text-xl" />
                                        );

                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {version}
                                                </div>
                                                {platformIcon}
                                            </div>
                                        )
                                       /* data = (
                                            /!*<div className="text-sm font-bold dark:text-white min-w-[120px]">*!/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value}
                                                </div>
                                            </div>
                                        );*/
                                    }else if (cell.column.Header === "Status") {
                                        data = (
                                            <div
                                                className={`flex w-[95px] items-center justify-center rounded-[10px] py-1.5 text-sm font-bold uppercase ${
                                                    cell.value.toString() === "0"
                                                        ? "bg-red-100 text-red-500 dark:bg-red-50"
                                                        : cell.value.toString() === "1"
                                                            ? "bg-orange-100 text-orange-500 dark:bg-orange-50"
                                                            : "bg-green-100 text-green-500 dark:bg-green-50"
                                                }`}
                                            >
                                                {cell.value.toString() === "0"
                                                    ? "Open"
                                                    : cell.value.toString() === "1"
                                                        ? "Ongoing"
                                                        : "Closed"}
                                            </div>
                                        );
                                    } else if (cell.column.Header === "") {
                                        data = (
                                            <button className="text-xl text-gray-600">
                                                <MdEdit/>
                                            </button>
                                        );
                                    } else if (
                                        ["Created Time", "Last Updated"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /*<div className="text-sm font-bold dark:text-white min-w-[120px]">*/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {convertGMTtoIST(cell.value)}
                                                </div>
                                            </div>
                                        );
                                    }

                                    return (
                                        <td
                                            className="py-[14px] pl-2 pr-4 align-middle"
                                            {...cell.getCellProps()}
                                            key={index}
                                        >
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            {/* pagination */}
            <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                {/* left side */}
                <div className=" flex items-center gap-3">
                    <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                        Show rows per page{" "}
                    </p>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                        name=""
                        id=""
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div className="flex items-center gap-4">
                    <p className="text-sm font-bold text-gray-700 dark:text-white">
                        Page {currentPage + 1} of {totalPages}
                    </p>
                </div>
                {/* right side */}
                <div className="flex items-center gap-3">
                    {state.pageIndex !== 0 && (
                        <button
                            onClick={previousPage}
                            disabled={state.pageIndex === 0}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronLeft/>
                        </button>
                    )}
                    <p className="text-sm text-gray-700 font-bold dark:text-white ">
                        {currentPage + 1}
                    </p>
                    {state.pageIndex !== totalPages - 1 && (
                        <button
                            onClick={nextPage}
                            disabled={state.pageIndex === totalPages}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronRight/>
                        </button>
                    )}
                </div>
            </div>

        </Card>
    );
};

export default ManagementTable;
